import 'novella-agri/src/scss/overview/news-category-menu.scss';

export default class NewsCategoryMenu {
  constructor(args) {
    this.element = document.querySelector('#news-category-menu');
    this.menuItems = [...this.element.querySelectorAll('li')].filter(item => !item.classList.contains('active'));

    this.current = null;
    this.hoverClass = 'hover';

    this.addEvents();
  }

  addEvents() {
    this.menuItems.map(menuItem => {
      menuItem.addEventListener('mouseenter', e => {
        this.current = e.target;

        setTimeout(_ => {
          if (this.current === e.target) {
            menuItem.classList.add(this.hoverClass);
          }

        }, 150);
      });

      menuItem.addEventListener('mouseleave', e => {
        this.current = null;

        setTimeout(_ => {
          if (this.current !== e.target) {
            menuItem.classList.remove(this.hoverClass);
          }

        }, 250);
      });
    })
  }
}